module.exports = __webpack_public_path__ + "02_mole.9dc99b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer3/02_mole.png
// module id = LSem
// module chunks = 0